module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"incorrectValue":"Incorrect value"},"zh":{"incorrectValue":"值不正确"},"kr":{"incorrectValue":"잘못된 값"}}')
  delete Component.options._Ctor
}
